import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../App';
import TerminalStatusBar from './TerminalStatusBar';
import CommandPalette from './CommandPalette';
import IdleSessionGuard from './IdleSessionGuard';

const PUBLIC_PATHS = ['/', '/home', '/login', '/reset-password', '/accept-invitation', '/security/lock', '/request-access', '/privacy', '/terms', '/trust'];

export default function TerminalChrome() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const active = !!user
    && !PUBLIC_PATHS.includes(pathname)
    && !pathname.startsWith('/roadshow')
    && !pathname.startsWith('/verify-certificate');

  useEffect(() => {
    document.documentElement.classList.toggle('gcfe-terminal', active);
    return () => document.documentElement.classList.remove('gcfe-terminal');
  }, [active]);

  if (!active) return null;
  return (
    <>
      <TerminalStatusBar />
      <CommandPalette />
      <IdleSessionGuard />
    </>
  );
}
